import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Badge, Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { useState } from 'react';

const ITEM_HEIGHT = 48;

type Props = {
    subscriber: any;
    onClickRelogin: () => void;
    onClickLogout: () => void;
    onClickRemove: () => void;
};

const UsernameWithAvatarLocalMenu = (props: Props) => {
    const { subscriber, onClickRelogin, onClickLogout, onClickRemove } = props;

    const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
    const menuOpen = Boolean(menuAnchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setMenuAnchorEl(null);
    };

    return (
        <div>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={menuOpen ? 'long-menu' : undefined}
                aria-expanded={menuOpen ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <Badge color="error" variant="dot" invisible={subscriber?.isLoggedIn}>
                    <MoreVertIcon />
                </Badge>
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={menuAnchorEl}
                open={menuOpen}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '20ch',
                    },
                }}
            >
                <MenuItem
                    onClick={() => {
                        handleClose();
                        onClickRelogin();
                    }}
                >
                    <ListItemIcon>
                        <Badge color="error" variant="dot" invisible={subscriber?.isLoggedIn}>
                            <LoginIcon fontSize="small" />
                        </Badge>
                    </ListItemIcon>
                    <ListItemText>Relogin...</ListItemText>
                </MenuItem>
                <Divider />
                <MenuItem
                    disabled={!subscriber?.isLoggedIn}
                    onClick={() => {
                        handleClose();
                        onClickLogout();
                    }}
                >
                    <ListItemIcon>
                        <LogoutIcon fontSize="small" color="error" />
                    </ListItemIcon>
                    <ListItemText>
                        <Typography fontFamily={'inherit'} fontSize="inherit" color="error">
                            Logout...
                        </Typography>
                    </ListItemText>
                </MenuItem>
                <Divider />
                <MenuItem
                    onClick={() => {
                        handleClose();
                        onClickRemove();
                    }}
                >
                    <ListItemIcon>
                        <DeleteForeverIcon fontSize="small" color="error" />
                    </ListItemIcon>
                    <ListItemText>
                        <Typography fontFamily={'inherit'} fontSize="inherit" color="error">
                            Remove Page...
                        </Typography>
                    </ListItemText>
                </MenuItem>
            </Menu>
        </div>
    );
};

export default UsernameWithAvatarLocalMenu;
